import { PivotFieldTypeEnum } from '@ztechapps/common.contract'
import type { PivotCondition } from '@ztechapps/common.contract'
import { isPivotRelativeOperator } from '../is-pivot-relative-operator'
import { PIVOT_OPERATOR_LABELS } from '../pivot-operator-labels'
import { describePivotOperands } from './describePivotOperands'

/**
 * A Condition in the chip voice, e.g. `Begins with "0021"`, `Between 5 and 50` or `Last month`. A string field's
 * operands are quoted; `valueType` is left out where the field's type is unknown, which words them bare.
 */
export const describePivotCondition = (condition: PivotCondition, valueType?: PivotFieldTypeEnum): string => {
  const label = PIVOT_OPERATOR_LABELS[condition.operator]
  if (isPivotRelativeOperator(condition.operator)) return `${label} ${condition.unit ?? ''}`.trim()
  return `${label} ${describePivotOperands(condition.operator, condition.values, valueType === PivotFieldTypeEnum.String)}`
}
